"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InfoLabel: function() {
        return _InfoLabel.InfoLabel;
    },
    infoLabelClassNames: function() {
        return _useInfoLabelStylesstyles.infoLabelClassNames;
    },
    renderInfoLabel_unstable: function() {
        return _renderInfoLabel.renderInfoLabel_unstable;
    },
    useInfoLabelStyles_unstable: function() {
        return _useInfoLabelStylesstyles.useInfoLabelStyles_unstable;
    },
    useInfoLabel_unstable: function() {
        return _useInfoLabel.useInfoLabel_unstable;
    }
});
const _InfoLabel = require("./InfoLabel");
const _renderInfoLabel = require("./renderInfoLabel");
const _useInfoLabel = require("./useInfoLabel");
const _useInfoLabelStylesstyles = require("./useInfoLabelStyles.styles");
